import { render } from "./ProjectCommentReply.vue?vue&type=template&id=56ecb3d8"
import script from "./ProjectCommentReply.vue?vue&type=script&lang=js"
export * from "./ProjectCommentReply.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__